export const noImage = 'assets/img/no-img.jpg'